/* Salvona collection — view toggle, sort, filter dropdowns, endless scroll */
(function(){
  function init(root){
    if(root.dataset.svcInit) return; root.dataset.svcInit='1';
    root.classList.add('is-js');
    var KEY='sv-collection-view';
    function setView(m){root.setAttribute('data-view',m);root.querySelectorAll('[data-svc-view]').forEach(function(b){b.setAttribute('aria-pressed',b.dataset.svcView===m?'true':'false');});try{localStorage.setItem(KEY,m);}catch(e){}}
    var saved=root.dataset.view||'grid';try{saved=localStorage.getItem(KEY)||saved;}catch(e){}
    setView(saved);
    root.querySelectorAll('[data-svc-view]').forEach(function(b){b.addEventListener('click',function(){setView(b.dataset.svcView);});});

    var sel=root.querySelector('[data-svc-sort]');
    if(sel) sel.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sel.value);u.searchParams.delete('page');location.href=u.toString();});
    root.querySelectorAll('.svc-dd').forEach(function(d){d.addEventListener('toggle',function(){if(d.open)root.querySelectorAll('.svc-dd').forEach(function(o){if(o!==d)o.open=false;});});});
    document.addEventListener('click',function(e){if(!e.target.closest('.svc-dd'))root.querySelectorAll('.svc-dd[open]').forEach(function(o){o.open=false;});});

    var body=root.querySelector('.svc-body');
    var more=root.querySelector('[data-svc-more]');
    if(!body||!more) return;
    var next=body.dataset.next, total=+body.dataset.total||0, shown=+body.dataset.shown||0, busy=false, io=null;
    var grid=root.querySelector('.svc-grid'), tbody=root.querySelector('.svc-table tbody');
    var shownEl=root.querySelector('[data-svc-shown]'), bar=root.querySelector('.svc-bar span');
    function done(){root.classList.add('is-done');if(io)io.disconnect();}
    if(!next){done();return;}

    function load(){
      if(busy||!next) return; busy=true; root.classList.add('is-loading');
      var u=new URL(next,location.origin); u.searchParams.set('section_id',root.dataset.section);
      fetch(u.toString(),{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var cards=doc.querySelectorAll('.svc-grid > .svc-card'), rows=doc.querySelectorAll('.svc-table tbody > tr');
        cards.forEach(function(c){c.classList.add('svc-new');grid.appendChild(c);});
        if(tbody) rows.forEach(function(r){r.classList.add('svc-new');tbody.appendChild(r);});
        shown+=cards.length; if(shownEl) shownEl.textContent=shown;
        if(bar&&total) bar.style.width=Math.min(100,shown/total*100)+'%';
        var nb=doc.querySelector('.svc-body'); next=nb?nb.dataset.next:'';
        busy=false; root.classList.remove('is-loading');
        if(!next) done();
      }).catch(function(){busy=false;root.classList.remove('is-loading');});
    }
    more.addEventListener('click',load);
    if(root.dataset.infinite!=='false' && 'IntersectionObserver' in window){
      io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)load();});},{rootMargin:'800px 0px'});
      io.observe(root.querySelector('[data-svc-sentinel]'));
    }
  }
  function boot(){document.querySelectorAll('.svc').forEach(init);}
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
